export const state = () => ({
  accounts: [],
  currentAccountIndex: 0,
  totalAccounts: 0,
  linkedAccounts: [],
  selectedPrimaryAccountId: null,
  skippedSelectPrimary2: false,
  primaryAccountLoginAuthValue: null,
})

export const mutations = {
  setAccounts(state, accounts) {
    console.log('Committing accounts to Vuex:', accounts)
    state.accounts = accounts
  },
  setCurrentAccountIndex(state, index) {
    console.log('Setting current account index:', index)
    state.currentAccountIndex = index
  },
  setTotalAccounts(state, total) {
    console.log('Setting total accounts:', total)
    state.totalAccounts = total
  },
  setLinkedAccounts(state, rawAccounts) {
    // Committing linked accounts to Vuex
    const formattedAccounts = rawAccounts.map((account) => ({
      id: account.entity_uuid,
      lastLogin: account.last_logged_in || 'N/A',
      avatar: account.avatar || null,
      firstName: account.firstName || '',
      lastName: account.lastName || '',
      addressLine1: account.address_street || '',
      addressLine2: `${account.address_city || ''}, ${
        account.address_state || ''
      } ${account.address_zip || ''}`
        .replace(/^, | $/, '')
        .trim(),
      loginMethod: {
        type: account.loginMethod_type || 'unknown',
        value: account.loginMethod_value || 'N/A',
      },
      contactEmail: account.contact_email || null,
      contactPhone: account.contact_phone || null,
      hasAuditableData: account.has_auditable_data || false,
      hasScheduledPaymentOrBalance:
        account.has_scheduled_payment_or_balance || false,
    }))
    state.linkedAccounts = formattedAccounts
  },
  setSelectedPrimaryAccountId(state, accountId) {
    state.selectedPrimaryAccountId = accountId
  },
  setSkippedSelectPrimary2(state, skipped) {
    state.skippedSelectPrimary2 = skipped
  },
  setprimaryAccountLoginAuthValue(state, authValue) {
    state.primaryAccountLoginAuthValue = authValue
  },
}

export const actions = {
  setSelectedPrimaryAccount({ commit }, accountId) {
    commit('setSelectedPrimaryAccountId', accountId)
  },

  setSkippedSelectPrimary2({ commit }, skipped) {
    commit('setSkippedSelectPrimary2', skipped)
  },

  setprimaryAccountLoginAuthValue({ commit }, authValue) {
    commit('setprimaryAccountLoginAuthValue', authValue)
  },

  async fetchHasDuplicateAccounts({ commit }) {
    try {
      const response = await this.$axios.$get(
        `/CORE_URL/entity/potential-duplicates-fetch`
      )

      const data = response.potential_duplicate_results || []
      // If the user has POTENTIAL_DUPLICATES, we expect to see two accounts:
      // the currently authenticated account and the duplicate account
      if (data.length === 2) {
        console.log(data)
        const accounts = data.map((result) => ({
          uuid: result.entity_uuid,
          initial: result.first_name.charAt(0).toUpperCase(),
          name: `${result.first_name} ${result.last_name}`,
          contact: result.email || result.phone || 'No contact info available',
        }))
        commit('setAccounts', accounts)

        return true
      } else {
        return false
      }
    } catch (error) {
      console.error('Error fetching duplicates:', error)
      return false
    }
  },

  async getHasDuplicateAccounts({ state, dispatch }) {
    try {
      if (state.accounts.length === 0) {
        const hasDuplicateAccounts = await dispatch('fetchHasDuplicateAccounts')
        return hasDuplicateAccounts
      } else {
        return false
      }
    } catch (error) {
      console.error('Error checking fetch duplicates states', error)
      return false
    }
  },

  async fetchHasLinkedAccounts({ commit }) {
    try {
      const linkedAccountsRaw = await this.$axios.$get(
        `/CORE_URL/entity/linked-accounts-details`
      )

      // Ensure linkedAccounts is always an array
      const linkedAccounts = Array.isArray(linkedAccountsRaw)
        ? linkedAccountsRaw
        : []

      // Commit the accounts to the store
      commit('setLinkedAccounts', linkedAccounts)

      // If we have linked accounts, redirect to select-primary-1
      return linkedAccounts.length > 0
    } catch (error) {
      console.error('Error fetching linked accounts:', error)
      return false
    }
  },

  async getHasLinkedAccounts({ state, dispatch }) {
    try {
      if (state.linkedAccounts.length === 0) {
        const hasLinkedAccounts = await dispatch('fetchHasLinkedAccounts')
        return hasLinkedAccounts
      } else {
        return false
      }
    } catch (error) {
      console.error('Error checking fetch linked accounts', error)
      return false
    }
  },
}
